// extracted by mini-css-extract-plugin
export default {"chatRibbon":"kY_kZ","chatRibbon__sliderCnt":"kY_k0"};